import { Box, Grid } from '@mui/material';
import {StartSection, OrganizationSection, TypeObraSection} from './components/sections';
import { GeneralDataDetails, WandaProject } from '../../../types/ObraDetails';
import styles from './generalData.module.scss';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ObrasAPI from '../../../services/APIObras';
import ErrorDetails from '../components/ErrorDetails/ErrorDetails';
import GeneralDataSkeleton from './components/generalDataSkeleton/generalDataSkeleton';

interface GeneralDataProps {
  codCentro: string;
  wandaProject?: WandaProject;
  wandaProjectLoading: boolean;
  wandaProjectError: boolean;
}

const GeneralData = ({
  codCentro,
  wandaProject,
  wandaProjectLoading,
  wandaProjectError,
}: GeneralDataProps) => {
  const [t] = useTranslation();
  const [generalData, setGeneralData] = useState<GeneralDataDetails>();
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setGeneralData(undefined);
    setLoadError(false);
    if (!wandaProject) return;

    ObrasAPI.getInstance().getObraGeneralDataAPI(codCentro, wandaProject)
      .then((response) => {
        setGeneralData(response);
      })
      .catch(() => {
        setLoadError(true);
      });
  }, [codCentro, wandaProject]);

  if (loadError || wandaProjectError) return <ErrorDetails />;
  if (!generalData || wandaProjectLoading) return <GeneralDataSkeleton />;

  const timestamp = generalData.general.fechaUltimaValidacion;
  const formattedDate = timestamp
    ? moment(timestamp).format('DD/MM/YYYY')
    : 'Fecha no disponible';

  const originCecoc = generalData.aspectosTecnicos.tiposObras.filter(
    ({ origen }) => origen === 'cecoc'
  );
  const originPhia = generalData.aspectosTecnicos.tiposObras.filter(
    ({ origen }) => origen === 'phia'
  );

  return (
    <Box
      sx={{
        pl: 2,
        pr: 2,
        margin: 'auto',
        fontFamily: 'Roboto',
        width: '95%',
      }}
    >
      <Grid
        container
        spacing={8}
        direction="column"
        className={styles.generalDataWrapper}
      >
        {generalData.general.fechaUltimaValidacion && (
          <div className={styles.lastUpdate} id='lastUpdate'>{t('details.validationDate')}:
            <span className={styles.lastUpdateDate} id='lastUpdateDate'> {formattedDate}</span>
          </div>
        )}
        <StartSection obra={generalData}/>
        <OrganizationSection obra={generalData}/>
        <TypeObraSection originCecoc={originCecoc} originPhia={originPhia}/>
        <div className='footer' style={{marginBottom: '75px'}}></div>
      </Grid>
    </Box>
  );
};

export default GeneralData;
